/**
 * /confidentialite — Politique de confidentialité (Phase 11).
 */
import { LegalDocument } from '@/pages/LegalDocument';
import { privacyFr } from '@/lib/legal/privacy_fr';
import { privacyEn } from '@/lib/legal/privacy_en';
import { useLang, useT } from '@/lib/i18n';

export default function Privacy() {
  const { lang } = useLang();
  const t = useT();
  const doc = lang === 'en' ? privacyEn : privacyFr;
  return (
    <LegalDocument
      doc={doc}
      path="/confidentialite"
      testid="page-privacy"
      courtesyNote={lang === 'en' ? t('legal.courtesy_note') : null}
    />
  );
}
